import { WorkflowStatusName } from "../items";
import { ReceptionCommentSet } from "../reception";
import { ReceptionCommentDispInfo } from "../reference";
import { WorkflowDocumentPermissions } from ".";
import { ReceptionDispInfo } from "..";

// 依頼文書参照用モデル
export class WorkflowDocumentViewer {
  public targetId: number;
  public documentId: number;
  public permissions: WorkflowDocumentPermissions;
  public status: WorkflowStatusName;

  public labelSetting: ReceptionDispInfo;
  public commentSetting: ReceptionCommentDispInfo;
  public commentSet: ReceptionCommentSet;

  public lastWorkflowHistoryId: string; // データ取得時点の最終WF履歴ID（排他制御用）
  public isTargetDeleted: boolean;
}
